export const imageSizeTypes = ['thumbnail', 'tiny', 'small', 'medium', 'large', 'full'] as const
export type ImageSizeType = (typeof imageSizeTypes)[number] | number

export const videoSizes = ['large', 'original'] as const
export type VideoSize = (typeof videoSizes)[number]
